var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1923 40.8121L24.9873 35.6071C24.4023 35.0221 23.4573 35.0221 22.8723 35.6071C22.2873 36.1921 22.2873 37.1371 22.8723 37.7221L29.1423 43.9921C29.7273 44.5771 30.6723 44.5771 31.2573 43.9921L47.1273 28.1221C47.7123 27.5371 47.7123 26.5921 47.1273 26.0071C46.5423 25.4221 45.5973 25.4221 45.0123 26.0071L30.1923 40.8121Z",
    fill: "#33AB84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0ZM35 3.78378C52.2402 3.78378 66.2162 17.7598 66.2162 35C66.2162 52.2402 52.2402 66.2162 35 66.2162C17.7598 66.2162 3.78378 52.2402 3.78378 35C3.78378 17.7598 17.7598 3.78378 35 3.78378Z",
    fill: "#E5E5EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0ZM35 3.78378C52.2402 3.78378 66.2162 17.7598 66.2162 35C66.2162 52.2402 52.2402 66.2162 35 66.2162C17.7598 66.2162 3.78378 52.2402 3.78378 35C3.78378 17.7598 17.7598 3.78378 35 3.78378Z",
    fill: "#33AB84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon_check_circle.ee09507682ef3b0dd959fee9f95c3215.svg";
export { ForwardRef as ReactComponent };